/**
 * Definición de campos del form "Nuevo Cliente".
 * El backend valida y rechaza lo que no encaje; el front
 * solo refleja la forma del DTO.
 */
export const TIPO_EMPRESA_OPTIONS = [
  { value: 'Persona Natural', label: 'Persona Natural' },
  { value: 'S.A.S', label: 'Sociedad por Acciones Simplificada (S.A.S)' },
  { value: 'S.A.', label: 'Sociedad Anónima (S.A.)' },
  { value: 'Ltda.', label: 'Sociedad Limitada (Ltda.)' },
  { value: 'Otro', label: 'Otro' },
];

export const ESTADO_OPTIONS = [
  { value: 'Activo', label: 'Activo' },
  { value: 'Inactivo', label: 'Inactivo' },
];

export const clientFormFields = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: false,
    defaultValue: 'Activo',
    options: ESTADO_OPTIONS,
  },
  {
    id: 'tipoEmpresa',
    label: 'Tipo de empresa',
    type: 'select',
    required: true,
    placeholder: 'Seleccionar…',
    options: TIPO_EMPRESA_OPTIONS,
  },
  {
    id: 'nombre',
    label: 'Nombre / Razón social',
    type: 'text',
    required: true,
    placeholder: 'Razón social o nombre comercial',
    icon: 'building',
  },
  {
    id: 'nombreContacto',
    label: 'Nombre contacto',
    type: 'text',
    required: false,
    placeholder: 'Representante',
    icon: 'user',
  },
  {
    id: 'nit',
    label: 'NIT',
    type: 'text',
    required: true,
    placeholder: '900123456',
  },
  {
    id: 'correo',
    label: 'Correo electrónico',
    type: 'email',
    required: true,
    placeholder: 'correo@empresa.com',
    icon: 'mail',
  },
  {
    id: 'telefono',
    label: 'Teléfono',
    type: 'text',
    required: false,
    placeholder: '+57 300 000 0000',
    icon: 'phone',
  },
  {
    id: 'direccion',
    label: 'Dirección',
    type: 'text',
    required: false,
    placeholder: 'Dirección',
  },
];
